const getCover = (data) => {
  // console.log(a);
  const {
    columnInfo: { names, attTypes, ids },
    rows,
  } = data;
  // console.log(data);
  const arrContent = rows[0].cells;
  const arr = names.map((i, e) => {
    return { name: i, val: arrContent[e].val, type: attTypes[e], id: ids[e] };
  });
  return arr;
};

const getTableData = (table) => {
  let arr = table.rows;
  let Arr = arr.map((i) => {
    i.cells = i.cells.map((i) => {
      if (!i) {
        return { val: "" };
      }
      return i;
    });
    // console.log(i.cells);
    return {
      number: i.cells[0].val,
      des: i.cells[1].val,
      statusLabel: i.cells[3].val,
      hasReject: i.cells[2].val,
      statusId: i.cells[3].id,
      workflow: i.cells[4].val,
      submitDate: i.cells[7]?.val || "",
      createDate: i.cells[5]?.val || "",
      completeDate: i.cells[6]?.val || "",
      seriesId: {
        id: i.cells[0].id,
        classId: i.cells[0].classId,
        subClassId: i.cells[0].subclassId,
      },
      rowId: i.rowId ? i.rowId : "",
    };
  });
  return Arr;
};

const getLoadTableData = (obj) => {
  // console.log(a);
  const {
    columnInfo: { names, attTypes, ids },
    rows,
  } = obj;
  const column = names.map((i, e) => ({ name: i, id: "pro" + ids[e] }));

  const data = rows.map((i) => {
    const rowItem = i.cells;
    let obj = {};
    rowItem.map((j, e) => {
      const key = column[e].id;
      obj[key] = j?.val || "";
    });
    return obj;
  });
  return { column, data };
};

const getStatusVal = (arr, obj) => {
  const {
    columnInfo: { names, attTypes, ids },
    rows,
  } = obj;
  const n = arr.map((i) => {
    const n = ids.findIndex((j) => j == i);
    const arrContent = rows[0].cells;
    return arrContent[n]?.id || "";
  });
  return n;
};

export default {
  getCover,
  getLoadTableData,
  getStatusVal,
  getTableData,
};
